import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const PumpPressure = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      id="pumpPressure"
      name="pumpPressure"
      label="Pump Pressure"
      disabled={!isEnableInfoTabEdit}
      placeholder="Enter pump pressure"
    />
  );
};

export default PumpPressure;
